export const apiUrl =
  'https://api.coingecko.com/api/v3/coins/flow-protocol/?tickers=true&market_data=false&community_data=false&developer_data=false&sparkline=false';
